import React, { useEffect, useState } from 'react';
import partnerQueries from '../../queries/partnerQueries';
import { BASE_URL } from '../../apis/api';
import speakersBg from '../../images/cover/speakers-bg.jpg';

function FestivalPartner() {
    const [partners, setPartners] = useState([]);
    const REACT_APP_BASE_URL = BASE_URL;

    const size = 100;
    const page = 0;

    // Mutation to fetch partners
    const Partners = partnerQueries.usePartnerSiteListingMutation(
        async (response) => {
            setPartners(response?.data?.items || []);
        },
    );

    // Fetch partners on component mount
    useEffect(() => {
        Partners.mutateAsync({
            size: size,
            page: page,
        });
    }, []);

    return (

        <div
            className="py-16 px-4 relative overflow-hidden sponsors"
        // Optional background image
        // style={{
        //   backgroundImage: `url(${speakersBg})`,
        //   backgroundSize: 'cover',
        //   backgroundPosition: 'center',
        //   backgroundRepeat: 'no-repeat',
        // }}
        >
            <div className="max-w-screen-xl mx-auto text-center">

                {/* Section Heading */}
                <div className="mb-8 sm:mb-12 md:mb-16">
                    <div className="flex items-center justify-center mb-4 sm:mb-6">
                        <div className="h-px bg-gradient-to-r from-transparent via-yellow-400 to-transparent flex-1 max-w-16 sm:max-w-24 md:max-w-32"></div>
                        <h4 className="text-xl sm:text-2xl md:text-3xl font-semibold text-gray-800 mx-4 sm:mx-6 md:mx-8 relative">
                            <span className="bg-gradient-to-r from-gray-800 via-gray-700 to-gray-600 bg-clip-text text-black">
                                OUR SPONSORS
                            </span>
                            <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-10 sm:w-12 md:w-16 h-1 bg-gradient-to-r from-yellow-400 to-yellow-500 rounded-full"></div>
                        </h4>
                        <div className="h-px bg-gradient-to-r from-transparent via-yellow-400 to-transparent flex-1 max-w-16 sm:max-w-24 md:max-w-32"></div>
                    </div>
                </div>

                {/* Sponsor Logos */}
                {partners.length > 0 ? (
                    <div className="flex flex-wrap justify-center gap-20">
                        {partners.map((partner) => (
                            <div
                                key={partner.id}
                                className="max-w-[150px] sm:w-3/4 md:w-[48%] lg:w-auto flex justify-center"
                            >
                                <img
                                    src={`${REACT_APP_BASE_URL}/${partner?.image}`}
                                    alt={partner.name || 'Partner Logo'}
                                    title={partner?.name}
                                    className="max-h-24 object-contain"
                                />
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="text-center mt-4">
                        <p className="text-gray-500">No partners available.</p>
                    </div>
                )}
            </div>
        </div>

    );
}

export default FestivalPartner;
